var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.description) ? _c('p', {
    staticClass: "text-muted pb-2"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/file/upload"
    }
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button mb-2",
    attrs: {
      "size": "sm"
    }
  }, [_vm._v("Upload File")])], 1), _vm._v(" "), _c('AdminTableContainer', {
    attrs: {
      "users": _vm.localFiles,
      "headers": _vm.headers,
      "options": _vm.options
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55c4be37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/FileMgmt/FileMgmt.vue
// module id = 4HWa
// module chunks = 2